import React from 'react';
import styled from 'styled-components';

const FooterSection = styled.footer`
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 20px;
`;

function Footer() {
  return (
    <FooterSection>
      <p>&copy; {new Date().getFullYear()} {process.env.REACT_APP_NAME}. All rights reserved.</p>
    </FooterSection>
  );
}

export default Footer;
